/**
 * Route-level authorization refusals from the API's CheckPermission / CheckUserRole
 * middleware. These mean the UI offered - or speculatively fetched - something this user's
 * permissions do not cover, so there is nothing for the user to act on and no message worth
 * showing. Suppressed centrally, matching how they behaved while the API still returned 401
 * for them (a 401 was swallowed here and handled as a session expiry by the response
 * interceptor); keying on error_code rather than the status code keeps this working if the
 * status is ever revised again.
 *
 * Deliberately narrow: a controller's own 403 (NO_ACCESS_TO_COMPANY, FORBIDDEN, and so on)
 * carries a message that tells the user something real, and still surfaces.
 */
const SUPPRESSED_AUTHORIZATION_ERROR_CODES = [
  'INVALID_PERMISSIONS_FOR_ROUTE',
  'INVALID_ROLE_FOR_ROUTE'
]

const translateError = (error: any) => {
  if (error.status === 401 && error.config && error.config.url !== 'auth/session') {
    return null
  }
  if (SUPPRESSED_AUTHORIZATION_ERROR_CODES.includes(error.data?.error_code)) {
    return null
  }
  if (error.status === 404) {
    return null
  }
  if (error.data?.errors) {
    const errors = error.data.errors
    if (Array.isArray(errors)) {
      return errors.join('<br>')
    } else if (typeof errors === 'object') {
      let message = ''
      for (const key in errors) {
        const errorKey = key === '' ? 'error' : key
        message += `${errorKey}: ${errors[key]}<br>`
      }
      return message
    }
  } else if (error.data && error.data.error_message) {
    return error.data.error_message
  } else if (error.data && error.data.message) {
    return error.data.message
  }
  return 'There was an unexpected error. Please contact support.'
}
export default translateError
